module.exports = __webpack_public_path__ + "assets/yuanxiaojie.91892a9a.svg";